export interface NewsArticle {
  id: string;
  title: string;
  date: string;
  category: string;
}

export const newsArticles: NewsArticle[] = [
  {
    id: "turo-variable-host-share-march-2026",
    title: "Turo's March 31 Updates: Variable Host Share",
    date: "March 16, 2026",
    category: "Turo Updates",
  },
];

export const getNewsArticleById = (id: string): NewsArticle | undefined => {
  return newsArticles.find((a) => a.id === id);
};
